import { useEffect, useState } from "react";
import SelectBox from "./SelectBox";

const ChatUserLisetSelector = ({
  groupMembers,
  change,
  availableUsers = [],
}) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (availableUsers?.length) {
      const mappedUsers = availableUsers.map((user) => ({
        value: user.id,
        label: `${user.name} (${user.role})`,
      }));

      setUsers(mappedUsers);
    }
  }, [availableUsers]);

  return (
    <>
      <SelectBox
        options={users}
        name='groupMembers'
        val={groupMembers}
        change={change}
        isMulti={true}
      />
    </>
  );
};

export default ChatUserLisetSelector;
